import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../store/auth.store';
import { LocalStorageService } from '../services/local-storage.service';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const authStore = inject(AuthStore);
  const authToken2 = inject(AuthService).getToken();
  const authToken = inject(AuthStore).token();
  const tokenInStorage = localStorageService.getItem('auth_token');

  const bypassUrls = [
    '/api/users/add',
    '/api/auth/send/otp',
    '/api/auth/verify/otp',
    '/api/loginAdmin',
  ];

  const shouldBypass = bypassUrls.some((url) => req.url.includes(url));

  if (shouldBypass) {
    return next(req);
  }

  if (!tokenInStorage) {
    authStore.logout();
    return next(req);
  }

    // Get the browser's timezone
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

     let headersConfig: Record<string, string> = {
      'Time-Zone': timeZone,  // Custom header for timezone
    };

    if (authToken) {
      headersConfig['Authorization'] = `Bearer ${authToken}`;
    }

     const clonedReq = req.clone({
      setHeaders: headersConfig,
    });

  // if (authToken) {
  //   req = req.clone({
  //     setHeaders: {
  //       Authorization: `Bearer ${authToken}`,
  //     },
  //   });
  // }

  return next(clonedReq);
};
